module.exports = __webpack_public_path__ + "static/media/about-icon-furniture.9ffe2331.svg";